var _g, _g2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 852,
    viewBox: "-20.21 56.72 333.89 177.33",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0d2c40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m93.09 176.17 20.91 1.54v17.86s-39.07 38.48-96-7.08h19.4l2.15-17.55s22.14 22.47 53.54 5.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.28 93.66s-42.49 39.56-7.7 90.21l19.42 1.85 1.85-18.78s-17.85-29.25 5.21-52.34l-20.68-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 90.89s53-34.17 93.29 7.08l-17.86-1.23-1.85 20s-20.32-24.62-54.18-5.53l-20.63-.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.1 121.68 1.23-20.63 18.78 1.85 56.65 63.11h-19.39l-1.85 17.55z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#02d35f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98.33 172.79 71.73-79.13 19.09 1.85-1.23 19.4-70.5 78.5.3-20.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.83 90.81 19.86 1.62-1.38 18.94s29.32-18.71 50.8 1.15l21 .92 1.89-18.44s-32.82-37-92.17-4.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.11 115.52 21 1.23 1.62-18.55s45.95 51.19-3.7 95.21l-20.31-1.41 1.85-21s27.48-30.77-.46-55.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.69 170.94-21.21-1.85-1.19 18.71s37.64 43.41 94.44 8.77l-19.4-1.57 1.85-20.09s-24.71 19.81-54.49-3.97z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m213.53 138.6v7a3.77 3.77 0 0 0 -.09.83 3.86 3.86 0 0 0 .09.84v11.28h-5.24v-20z",
    fill: "#0d2c40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m218.14 138.6a8.32 8.32 0 0 0 -4.61 2.17 8 8 0 0 0 -3.07 5.67 8.53 8.53 0 0 0 3.07 6 6.79 6.79 0 0 0 4.09 1.85c4.87.12 7.27-4.07 7.27-7.84s-2.98-8.07-6.75-7.85zm-1.59 11.31a3.19 3.19 0 0 1 -3-2.63 3.86 3.86 0 0 1 -.09-.84 3.77 3.77 0 0 1 .09-.83 3.19 3.19 0 0 1 3-2.63 3.48 3.48 0 0 1 0 6.93zm18.76-5.34c-.76-.24-3.57-.68-3.57-1.74 0-.6.86-.67 1.28-.65 1.2 0 3 1.43 4 1.16.89-.23 1.67-2.53 2-3.31a12.77 12.77 0 0 0 -8.34-1.52 5 5 0 0 0 -3.77 6.6c1.27 3.29 5.17 2 7.14 4 .81.84-.86 1.22-1.41 1.2a11.85 11.85 0 0 1 -4.74-1.8c-.49.7-2 2.37-1.82 3.24s2.17 1.52 3 1.78c2.78.9 7.07 1.24 9.16-1.29 2.61-3.04.33-6.61-2.93-7.67zm-40.69-11.51a11 11 0 1 0 11 11 11 11 0 0 0 -11-11zm0 16.61a5.64 5.64 0 1 1 5.65-5.64 5.64 5.64 0 0 1 -5.66 5.64z",
    fill: "#0d2c40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m90.44 138.35h-6.27l6.63 17.34h2.86v-7.39zm6.45.03h6.27l-6.64 17.34h-2.86v-7.39zm-36.89-2.47a15.09 15.09 0 0 0 -7.1-2.62c-3.38-.32-7 .09-10.13.09v22.29h.15c.6.07 1.2.13 1.81.17a39.73 39.73 0 0 0 7.22-.06c4.59-.51 7.54-2 9.35-3.94a10.11 10.11 0 0 0 2.55-6.54v-.53-.28c-.04-3.17-.95-6.36-3.85-8.58zm-5.1 13.62c-1.89 1.06-4.19.8-6.27.8v-11.61c2.21 0 4.7-.29 6.64 1.07 3.22 2.27 3.1 7.78-.4 9.74zm26.52 1.74c-.51-.43-1.16-1.16-1.85-1.28-1.1-.15-2.47 1.33-3.69 1.45-1.9.19-3.27-1.12-4-2.7h11.56c0-3.2-.27-6.57-3-8.77-5.07-4.14-13.39-1.08-14.32 5.45-1 6.88 4.41 11.32 11 10.46a8.64 8.64 0 0 0 4.42-2c.45-.4 1.11-.95.78-1.6a3.72 3.72 0 0 0 -.9-1.01zm-3.69-5.67h-5.9a3 3 0 0 1 5.9 0z",
    fill: "#02d35f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOps);
export default __webpack_public_path__ + "static/media/DevOps.141bf73b3e5ca698cfcc74f184c6ac33.svg";
export { ForwardRef as ReactComponent };